import type { Link } from 'mdast';
import type { State } from '../state';

export function link(state: State, node: Link): void {
	if (!state.schema.marks.link) {
		// Gracefully degrade: render children as plain text when schema has no link mark
		state.parseTokens(node.children);
		return;
	}
	const mark = state.schema.marks.link.create({ href: node.url, title: node.title ?? null });
	state.openMark(mark);
	state.parseTokens(node.children);
	state.closeMark(mark);
}
